import { createContext, useContext, useState } from "react";
import { Snackbar, Alert } from "@mui/material";
const SnackbarContext = createContext();

// Severity options:
// success
// error
// warning
// info

export const SnackbarProvider = ({ children }) => {
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "info"
  });

  const showSnackbar = (message, severity = "info") => {
    setSnack({
      open: true,
      message,
      severity
    });
  };

  const closeSnackbar = () => {
    setSnack(prev => ({ ...prev, open: false }));
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}

      {/* Global Snackbar UI */}
      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={closeSnackbar}
      >
        <Alert severity={snack.severity} variant="filled">
          {snack.message}
        </Alert>
      </Snackbar>

    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => useContext(SnackbarContext);